import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData, selectMerchantInfo } from 'store/termsAndConditions/termsAndConditionsSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { PageWithLoader } from 'pages/PageWithLoader';
import { TermsAndConditionsDE } from './TermsAndConditionsDE';

export const CBKGermanyTermsAndConditions = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const merchantInfo = useSelector(selectMerchantInfo);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    const account = searchParams.get('account');
    const jwt = searchParams.get('jwt');

    if (account && jwt) {
      dispatch(fetchData({ account, jwt }));
    }
  }, [dispatch, searchParams, setSearchParams]);

  return (
    <PageWithLoader>
      <TermsAndConditionsDE {...merchantInfo} />
    </PageWithLoader>
  );
};
